/* eslint-disable no-case-declarations */
import { types } from "../type";

const initialState = {
  hrError: "",
  hrStatus: 0,
  hrResponse: "",
  locationId: "",
  leaveList: [],
  myAppliedLeave: [],
  hrLoading: false,
  allDesignations: [],
  missingAttendanceList: [],
  allDepartments: [],
  allReportingManagers: [],
  reimbursementList: [],
  hrCreateLoading: false,
  reimbursementTypeId: "",
  reimbursementGetDate: ""
};

const hrReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.HrTypes.HR_SET_LOADING:
      return {
        ...state,
        hrLoading: payload
      };
    case types.HrTypes.HR_SET_CREATE_LOADING:
      return {
        ...state,
        hrCreateLoading: payload
      };
    case types.HrTypes.HR_CLEAR_ERRORS:
      return {
        ...state,
        hrError: ""
      };
    case types.HrTypes.HANDLE_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        hrResponse: payload.message
      };
    case types.HrTypes.ADD_DEPARTMENT_DESIGNATION_SUCCESS:
      const addData = payload.inputData.data.toUpperCase();
      if (payload.inputData.type === "designation") {
        state.allDesignations.push({
          designationName: addData
        });
      } else {
        state.allDepartments.push({
          departmentName: addData
        });
      }
      return {
        ...state,
        hrResponse: payload.message,
        hrError: ""
      };
    case types.HrTypes.GET_DESIGNATION:
      return {
        ...state,
        allDesignations: payload.allDesignations
      };
    case types.HrTypes.GET_DEPARTMENT:
      return {
        ...state,
        allDepartments: action.payload.allDepartments
      };
    case types.HrTypes.GET_ZONE:
      return {
        ...state,
        allZones: action.payload.allZones
      };
    case types.HrTypes.HR_GET_ERRORS:
      return {
        ...state,
        hrLoading: false,
        hrCreateLoading: false,
        hrError: payload.data.message,
        hrStatus: payload.status
      };
    case types.HrTypes.GET_ALL_REIMBURSEMENT:
      return {
        ...state,
        hrLoading: false,
        hrError: "",
        reimbursementList: payload.foundReimbursement
      };
    case types.HrTypes.ALL_MISSING_ATTENDANCE_LIST:
      return {
        ...state,
        hrLoading: false,
        hrError: "",
        missingAttendanceList: payload.foundMissingAttendanceList
      };
    // -----manager
    case types.HrTypes.GET_REPORTING_MANAGERS:
      return {
        ...state,
        hrLoading: false,
        allReportingManagers: payload.reportingManagers
      };
    case types.HrTypes.ADD_REPORTING_MANAGERS:
      return {
        ...state,
        hrLoading: false,
        hrResponse: payload.message
      };
    // -leave
    case types.HrTypes.GET_ALL_LEAVE:
      return {
        ...state,
        hrLoading: false,
        hrError: "",
        leaveList: payload.foundLeaves
      };
    case types.HrTypes.MY_APPLIED_LEAVE:
      return {
        ...state,
        hrLoading: false,
        hrError: "",
        myAppliedLeave: payload.myAppliedLeave
      };
    case types.HrTypes.APPLY_LEAVE:
      return {
        ...state,
        hrLoading: false,
        hrError: "",
        hrResponse: payload.message
      };
    case types.HrTypes.HR_INPUTS:
      return {
        ...state,
        reimbursementGetDate: payload.date,
        reimbursementTypeId: payload.typeId
      };
    case types.HrTypes.HR_UNMOUNT:
      return {
        ...state,
        reimbursementList: []
      };
    default:
      return state;
  }
};

export default hrReducer;
